export const PIXEL_CONSTANTS = {
  FACEBOOK: "2365278530483021",
  LINKEDIN: "6757148",
  REDDIT: "a2_g9su7byjf9mu",
  GOOGLE: "AW-16640138208",
  GOOGLE_REGISTRATION_CONVERSION_ID: "AW-16640138208/oVG4CLaU5LEbEOC30f49",
  GOOGLE_PREDICTION_CONVERSION_ID: "AW-16640138208/ZalpCKHn57EbEOC30f49",
  LINKEDIN_REGISTRATION_CONVERSION_ID: 22348676,
  LINKEDIN_PREDICTION_CONVERSION_ID: 22348684,
} as const;
